import React from 'react';
import { XCircle } from 'lucide-react';
export function FailedSolutionsSection() {
  const solutions = [{
    name: '"Just relax"',
    reason: 'That\'s not an instruction. It\'s like telling someone in a skid to "drive better."'
  }, {
    name: 'Pills',
    reason: 'They fix the physical but increase the mental pressure: "Now I really have to perform."'
  }, {
    name: 'Random advice',
    reason: "It doesn't address the exact moment of panic."
  }, {
    name: 'Trying harder',
    reason: 'It makes you monitor yourself more. And monitoring is the spark that ignites the spiral.'
  }, {
    name: '"Think positive"',
    reason: "Your nervous system doesn't respond to affirmations. It responds to sequences."
  }];
  return <section className="py-16 md:py-20 px-4 sm:px-6 bg-dark-card/30" data-id="element-46">
      <div className="max-w-4xl mx-auto" data-id="element-47">
        <h2 className="text-2xl md:text-3xl font-bold mb-12 text-center text-text-primary" data-id="element-48">
          Why Previous Solutions Have Failed You
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-12" data-id="element-49">
          {solutions.map((solution, index) => <div key={index} className={index === 4 ? 'md:col-span-2 lg:col-span-1' : ''} data-id="element-50">
              <div className="bg-dark-bg border border-dark-border p-6 rounded-xl h-full" data-id="element-51">
                <div className="flex items-center gap-3 mb-3" data-id="element-52">
                  <XCircle className="w-4 h-4 text-red-500/80" data-id="element-53" />
                  <h3 className="text-lg font-playfair font-bold text-text-primary" data-id="element-54">
                    {solution.name}
                  </h3>
                </div>
                <p className="text-text-secondary leading-relaxed" data-id="element-55">
                  {solution.reason}
                </p>
              </div>
            </div>)}
        </div>

        <div className="text-center max-w-2xl mx-auto bg-gold/10 border border-gold/20 p-6 rounded-xl" data-id="element-56">
          <p className="text-lg md:text-xl font-medium text-gold" data-id="element-57">
            The problem isn't motivation. It's that nobody ever gave you the
            right sequence.
          </p>
        </div>
      </div>
    </section>;
}